import React from 'react'

const AddViewPeople = () => {
  return (
    <>
      <section>
        <h1>Add View People</h1>
      </section> 
    </>
  )
}

export default AddViewPeople
